<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <slot name="title" />
      </v-col>
    </v-row>
    <slot name="content" />
    <br>
  </v-container>
</template>

<script>
export default {
  name: 'PageTemplate',
};
</script>
